<template>
	<Container>
		<TopBar />
		<div class="content">
			<div class="order-detail">
				<Row style="border: 1px solid rgba(0,0,0,0.05);">
					<Col :lg='8' class='order-left'>
					<p class="order-info">訂單信息(Order Information)</p>
					<div style="margin-left: 0.1rem;">
						<Row style="margin-top: 0.1rem;">
							<Col span='10'>訂單編號(Order Number):</Col>
							<Col span='14'>{{order.orderId}}</Col>
						</Row>
						<Row style="margin-top: 0.1rem;" v-if='order.originalID'>
							<Col span='10'>訂單來源(Order Source):</Col>
							<Col span='14'>{{convertChannel(order.channel)}}</Col>
						</Row>
						<Row style="margin-top: 0.1rem;">
							<Col span='10'>訂單類型(Order Type):</Col>
							<Col span='14'>{{order.lrp=='100'?'Standard':'LRP'}}&nbsp;<b v-if='lrptType==11'>Template</b></Col>

						</Row>
						<Row style="margin-top: 0.1rem;">
							<Col span='10'>收貨地址(Delivery Address):</Col>
							<Col span='14'>{{address}} <span v-if='canEditAddress' style="color: #BC86C8;text-decoration: underline;cursor: pointer;" @click='changeAddress'>修改地址</span></Col>
						</Row>
						<Row style="margin:0.1rem auto;">
							<Col span='10'>聯係電話(TelePhone):</Col>
							<Col span='14'>{{order.telephone}}</Col>
						</Row>

					</div>
					</Col>
					<Col :lg='16' class='track'>
					<h3>物流信息(Logistics Information)</h3>
					<div class="track-detail">
						<p>
							<span v-if='order.carrierName'>{{order.carrierName}}:</span><span v-else-if='deliveryStoreId != "501"'>{{deliveryName}}：</span><span>{{order.shippingNo}}</span>
							<Button class='show-btn' type='text' @click='showTrack=true' v-if='order.expressUrl&&order.expressUrl.indexOf("http")==0'>查看物流詳情</Button>
							<div v-if='deliveryStoreId != "501"'>精油生活館地址：{{shopAddress}}</div>	
						</p>
						<Modal v-model='showTrack' title="物流詳情" width='600'>
							<iframe :src="order.expressUrl" class="track-list"></iframe>
						</Modal>

					</div>

					<h3>發票信息(Invoice Information)</h3>
					<div class="track-detail">
						<p v-show="InvoiceLoad">{{InvoiceStatusText}}
							<a class='orderdetail-down' target="_blank" v-show="invoice.InvoiceStatus=='10'" v-on:click="InvoinceDown">下載發票</a>
							<a class='orderdetail-down' target="_blank" v-show="CanCancelInvoice" v-on:click="InvoinceCancel">作廢發票</a>
							<Button class='show-btn' type='text' @click='showInvoice=true' v-show='canInvoice'>{{InvoiceStatusBtnText}}</Button>
						</p>
						<p style="font-size: 13px;">請在訂單完成後的一個月內申請開具電子發票，如發票開具有誤請在開具後的30天內申請發票作廢，逾期後已開具的電子發票無法進行任何修改</p>
						<Modal v-model='showInvoice' title="發票詳情" width='600' ok-text="提交">
							<table class="Invoice-list">
								<tbody>
									<tr>
										<td class="Invoice-head"><span class="invoice-icon">*&nbsp;</span>類型:</td>
										<td class="Invoice-content">
											<span v-if="InvoiceStatus==0">
												<RadioGroup v-model="invoice.CompanyTypeText" type="button" size="large">
													<Radio label="個人"></Radio>
													<Radio label="企業"></Radio>
													<Radio label="機關事業單位"></Radio>
												</RadioGroup>
											</span>
											<span v-else>
												{{invoice.CompanyTypeText}}
											</span>
										</td>
										<td class="Invoice-right"></td>
									</tr>
									<tr>
										<td class="Invoice-head"><span class="invoice-icon">*&nbsp;</span>發票擡頭:</td>
										<td class="Invoice-content">
											<span v-if="InvoiceStatus==0 && isPersonal">
												<input type="text" class="ivu-input" v-model="invoice.InvoiceTitle" maxlength="50">
											</span>
											<span v-else>
												{{invoice.InvoiceTitle}}
											</span>
										</td>
										<td></td>
									</tr>
									<tr v-show="InvoiceStatus==0 && isPersonal">
										<td class="Invoice-head"></td>
										<td>
											<Select v-model="invoiceCompany" size="large" @on-change="chooseInvoiceInfo()">
												<Option v-for="(item,index) in invoiceInfo" :value="index" :key="item.Id">{{ item.InvoiceTitle }}</Option>
											</Select>
										</td>
										<td class="Invoice-right">
											<Button type="primary" class="btn-invoiceDelete" @click="deleteInvoiceInfo">刪除</Button></td>
									</tr>
									<tr v-show='isPersonal && showTaxPayerId'>
										<td class="Invoice-head"><span class="invoice-icon">*&nbsp;</span>納稅人識別號:</td>
										<td class="Invoice-content">
											<input type="text" class="ivu-input" v-model="invoice.TaxPayerId" v-if="InvoiceStatus==0" @blur="invoice.TaxPayerId=invoice.TaxPayerId.toUpperCase()"
											 maxlength="20">
											<!-- 1234567890 -->
											<span v-else>
												{{invoice.TaxPayerId}}
											</span>
										</td>
										<td class="Invoice-right" rowspan="6"></td>
									</tr>
									<tr v-show='isPersonal'>
										<td class="Invoice-head">地址:</td>
										<td class="Invoice-content">
											<!--上海-->
											<input type="text" class="ivu-input" v-model="invoice.Address" v-if="InvoiceStatus==0" maxlength="50">
											<!-- <RadioGroup v-model="invoice.Address" type="button" size="large" v-if="InvoiceStatus==0">
													<Radio label="上海" selected="true"></Radio>
												</RadioGroup> -->
											<span v-else>
												{{invoice.Address}}
											</span>
										</td>
									</tr>
									<tr v-show='isPersonal'>
										<td class="Invoice-head">電話:</td>
										<td class="Invoice-content">
											<input type="text" class="ivu-input" v-model="invoice.Phone" v-if="InvoiceStatus==0" maxlength="20">
											<!-- 15000000000 -->
											<span v-else>
												{{invoice.Phone}}
											</span>
										</td>
									</tr>
									<tr v-show='isPersonal'>
										<td class="Invoice-head">開戶銀行:</td>
										<td class="Invoice-content">
											<input type="text" class="ivu-input" v-model="invoice.BankName" v-if="InvoiceStatus==0" maxlength="20">
											<!-- 招商銀行閔行支行 -->
											<span v-else>
												{{invoice.BankName}}
											</span>
										</td>
									</tr>
									<tr v-show='isPersonal'>
										<td class="Invoice-head">銀行賬號:</td>
										<td class="Invoice-content">
											<input type="text" class="ivu-input" v-model="invoice.BankNo" v-if="InvoiceStatus==0" maxlength="20">
											<!-- 60000000000000 -->
											<span v-else>
												{{invoice.BankNo}}
											</span>
										</td>
									</tr>
									<!-- <tr v-show='isPersonal'>
										<td class="Invoice-head">郵箱:</td>
										<td class="Invoice-content">
											<input type="text" class="ivu-input" v-model="invoice.Email" v-if="InvoiceStatus==0" maxlength="20">
											<span v-else>
												{{invoice.Email}}
											</span>
										</td>
									</tr> -->
								</tbody>
							</table>
							<div slot="footer">
								<Button type="text" v-show="InvoiceStatus==0" v-on:click="cancelInvoice()">取消</Button>
								<Button type="primary" v-on:click="submitInvoice()">確定</Button>
							</div>
						</Modal>
						<Modal v-model='showInvoiceLink' title="發票文件" width='600'>
							您的發票文件已生成，點擊確認後開始下載或者輸入郵箱地址，我們將通過郵件發送給您。<br>
							<input type="text" class="ivu-input" v-model="InvoiceEmail" maxlength="50" placeholder="郵箱地址">
							<div slot="footer">
								<Button type="text" v-on:click="cancelInvoiceLink()">取消</Button>
								<a v-bind:href="pdfUrl" target="_blank" class="orderdetail-downLink ivu-btn ivu-btn-primary">下載</a>
								<Button type="text" v-on:click="PostInvoiceEmail()" class="ivu-btn ivu-btn-primary">發送郵件</Button>
							</div>
						</Modal>
						<Modal v-model='confirmInvoice' title="信息" width='600' ok-text="確認" @on-ok="postInvoice">
							請再次確認納稅人識別號是否正確
						</Modal>
					</div>
					</Col>
				</Row>
				<Table class='products' stripe :columns="columns" :data="order.Details"></Table>
				<Row style="background-color: #f3f3f3;margin-top: 0.5rem;">
					<Col :lg='{span:9, push:15}' class="fee">
					<Row>
						<Col :lg='12' :xs='18'>回饋點數兌換(PT):</Col>
						<Col :lg='12' :xs='6'>{{order.totalPoint||'0'}}</Col>
						<Col :lg='12' :xs='18'>訂單金額/PV (Order Amount/PV):</Col>
						<Col :lg='12' :xs='6'>HK${{order.total}}&nbsp;/&nbsp;{{order.PV||'0'}}</Col>
						<Col :lg='12' :xs='18'>其他費用 (Other Expenses):</Col>
						<Col :lg='12' :xs='6'>HK${{order.feeTotal}}</Col>
						<Col :lg='12' :xs='18'>訂單總計 (Order Total):</Col>
						<Col :lg='12' :xs='6'>HK${{order.grandTotal}}</Col>
						<Col :lg='12' :xs='18' style='color:orange'>産品積分 (Product Credits):</Col>
						<Col :lg='12' :xs='6' style='color:orange'>{{order.totalAr}}</Col>
						<Col :lg='12' :xs='18' style='font-weight: bold;font-size: 14px;'> 支付金額 (Payment Amount):</Col>
						<Col :lg='12' :xs='6' style='font-weight: bold;font-size: 14px;'>HK${{ actualPay || '0'}}</Col>
					</Row>
					</Col>
				</Row>
			</div>
		</div>
		<editAddressView title='修改收貨人' :editAddress='editAddress' :show='show' @confirm='asyncOK' @cancel='show=false' :loading='addressLoading'></editAddressView>
	</Container>

</template>

<script>
	import TopBar from "@/components/common/TopBar";
	import editAddressView from "@/components/order/editAddressView";
	import {RE_EMAIL} from '@/components/common/regex';
	import util from '@/config/util';
	import {
		mapState,
		mapActions,
		mapMutations,
		mapGetters
	} from 'vuex'
	export default {
		data() {
			return {
				columns: [
					{
						key: 'name',
						renderHeader: (h, index) => {
							return h('div', [
								h('div', null, '商品'), h('div', null, 'Commodity')])
						}
					},
					{
						key: 'price',
						renderHeader: (h, index) => {
							return h('div', [
								h('div', null, '單價'), h('div', null, 'Unit Price')])
						}
					},
					{
						key: 'PV',
						renderHeader: (h, index) => {
							return h('div', [
								h('div', null, 'PV')])
						}
					},
					{
						key: 'qty',
						renderHeader: (h, index) => {
							return h('div', [
								h('div', null, '數量'), h('div', null, 'quantity')])
						}
					},
					{
						key: 'subTotal',
						renderHeader: (h, index) => {
							return h('div', [
								h('div', null, '金額小計'), h('div', null, 'SubTotal')])
						}
					},
				],

				order: {},
				from: 'orders',
				showTrack: false,
				showInvoice: false,
				invoice:
				{
					TaxPayerId: '',
					InvoiceTitle: '個人',
					CompanyTypeText: '個人',
					CompanyType: '03',
					Address: '上海',
					Phone: '',
					BankName: '',
					BankNo: '',
					Email: '',
					InvoiceStatus: '0'
				},
				invoiceInfo: {},
				invoiceCompany: '',
				InvoiceStatusBtnText: '申請開具發票',
				InvoiceLoad: false,
				loading: true,
				canInvoice: true,
				CanCancelInvoice:false,
				pdfUrl: '',
				showInvoiceLink: false,
				confirmInvoice: false,
				lrptType: 0,
				deliveryStoreId:'501',
				delivery:{},
				shopAddress:'',
				deliveryName:null,
				showTaxPayerId:true,
				InvoiceEmail:'',
				editAddress:{
                    id:0,
                    name:null,
                    province_id:null,
                    moblie_phone:null,
                    city_id:null,
                    county_id:null,
                    town_id:null,
                    street:null,
                    street2:null,
                    zip :null,
                    email :null,
                    is_default:'0',
                    tag_type:'0',
                    address_type:'1',
                },
                show:false,
                addressLoading:false,

			}
		},
		components: {
			TopBar,
			editAddressView,
		},
		created() {
			this.$nextTick(function () {
				this.initData()
			});
		},
		computed: {
			...mapState({
				userInfo: state => state.common.wechatUserInfo,
			}),
			address() {
				let order = this.order
				if (this.delivery.ProvinceName) {
					return `${this.delivery.ProvinceName} ${this.delivery.CityName} ${this.delivery.CountyName} ${this.delivery.TownName||''} ${this.delivery.Street}`;
				}
				if (order.region) {
					return `${order.region} ${order.city} ${order.district} ${order.TownName||''} ${order.street}`;
				}
				return ''
			},
			actualPay() {
				let actualPay = parseFloat(this.order.grandTotal) - parseFloat(this.order.totalAr);
				return actualPay.toFixed(2);
			},
			canEditAddress(){
				let editable = true
				if (this.deliveryStoreId != '501') return false
				if(this.order.createTime){
					let now = new Date()
					let payTime = util.formatDate.dateFromStr(this.order.createTime)
					if (now - payTime > 1800000)  {
						return false
					}
				} else {
					return false
				}
				let channel = (this.order.channel || '').toLowerCase()
				if (!(['myo','wechat','moblieapp'].includes(channel))) return false
				if (this.order.orderStatus != 20) return false
				return editable
			},
			CompanyTypeText() {
				//01：企業  02：機關事業單位 03：個人  04：其它
				if (this.invoice.CompanyType == '01') {
					return '企業'
				}
				else if (this.invoice.CompanyType == '02') {
					return '機關事業單位'
				}
				else if (this.invoice.CompanyType == '03') {
					return '個人'
				}
				else if (this.invoice.CompanyType == '04') {
					return '其他'
				}
				return '個人'
			},
			CompanyType() {
				//01：企業  02：機關事業單位 03：個人  04：其它
				if (this.invoice.CompanyTypeText == '企業') {
					return '01'
				}
				else if (this.invoice.CompanyTypeText == '機關事業單位') {
					return '02'
				}
				else if (this.invoice.CompanyTypeText == '個人') {
					return '03'
				}
				else if (this.invoice.CompanyTypeText == '其他') {
					return '04'
				}
				return '03'
			},
			InvoiceStatus() {
				if (this.invoice.InvoiceStatus == "00" || this.invoice.InvoiceStatus == "10") {
					return 1;//發票開具中\已開具發票，直接顯示發票信息，不能再次申請
				}
				else {
					return 0;
				}
			},
			InvoiceStatusText() {
				if (this.invoice.InvoiceStatus == "00") {
					return "發票開具中"
				}
				else if (this.invoice.InvoiceStatus == "10") {
					return "已開具發票"
				}
				else if (this.invoice.InvoiceStatus == "-1") {
					return "開票失敗"//開票失敗，顯示上次開票信息，可以再次申請
				}
				else{
					return "未開具發票";
				}
			},
			isPersonal() {
				if (this.invoice.CompanyType == '03') {
					return false;
				}
				else {
					return true;
				}
			}
		},
		watch: {
			'invoice.CompanyTypeText'(value) {
				console.log('類型修改')
				console.log(value)
				this.invoice.CompanyType=this.CompanyType;
				if (this.InvoiceStatus == 0) {
					if (value == '個人') {
						this.invoice.InvoiceTitle = '個人';
						this.showTaxPayerId=true;
					}
					else if (value == '企業') {
						if (this.invoice.InvoiceTitle == '個人') {
							this.invoice.InvoiceTitle = this.userInfo.value.binding.company.company_name;
						}
						if (this.userInfo.value.binding.customer_type.toLowerCase() == 'vipbiz' || this.userInfo.value.binding.customer_type.toLowerCase() == 'sa') {
							if (this.invoice.InvoiceTitle == '') {
								this.invoice.InvoiceTitle = this.userInfo.value.binding.company.company_name;
							}
							if (this.invoice.Phone == '') {
								this.invoice.Phone = this.userInfo.value.binding.moblie_phone;
							}
							if (this.invoice.BankName == '') {
								this.invoice.BankName = this.userInfo.value.binding.bank.bank_name;
							}
							if (this.invoice.BankNo == '') {
								this.invoice.BankNo = this.userInfo.value.binding.bank.account_number;
							}
							if (this.invoice.Email == '') {
								this.invoice.Email = this.userInfo.value.binding.email;
							}
							if (this.invoice.Address == '上海' || this.invoice.Address == '') {
								this.invoice.Address = this.userInfo.value.binding.company.business_street;
							}
							console.log(this.invoice);
							console.log(this.wechatUserInfo);
						}
						else if (this.userInfo.value.binding.customer_type.toLowerCase() == 'pc') {
							if (this.invoice.Phone == '') {
								this.invoice.Phone = this.userInfo.value.binding.moblie_phone;
							}
						}
						this.showTaxPayerId=true;
					}
					else if(value == '機關事業單位'){
						this.showTaxPayerId=false;
					}
					else {
						if (this.invoice.InvoiceTitle == '個人') {
							this.invoice.InvoiceTitle = '';
						}
						this.showTaxPayerId=true;
					}
				}
			}
		},
		methods: {
			...mapActions([
				'getOMSOrderDetailAction',
				'getOrderInvoiceAction',
				'getInvoiceInfoAction',
				'postOrderInoviceAction',
				'postInvoiceInfoAction',
				'postDeleteInvoiceInfoAction',
				'GetInvoiceDownAction',
				'getOrderChannelAction',
				'getWXOrderDetailAction',
				'getWechatUserInfoAction',
				'GetInvoiceCancelAction',
				'postInvoiceEmailAction',
				'getInvoiceEmailAction',
				'changeOrderAddressAction',
				'postAddAddressAction'
			]),
			async initData() {
				this.from = this.$route.query.from || 'orders';
				let orderno = this.$route.query.orderNo;
				let channel = this.$route.query.channel
				let response = await this.getOMSOrderDetailAction(orderno);
				if (response) {
					var desc = await this.getWXOrderDetailAction(response.originalID);
					if (desc&&desc.delivery[0]) {
						this.deliveryStoreId = desc.delivery[0].DeliveryStoreId
						this.delivery = desc.delivery[0];
						this.shopAddress = desc.delivery[0].Address
						this.deliveryName = desc.delivery[0].DeliveryName
						response.expressUrl = desc.expressUrl
						this.lrptType = desc.delivery[0] && desc.delivery[0].LRPTemplateType
					}
					// if (channel.toLowerCase() == 'wx') {
					channel = await this.getOrderChannelAction({orderid:response.originalID});
					// }
					response.channel = channel
					this.order = response
					if (this.order.userId != this.userInfo.value.binding.register.vip_no) {
						this.$router.push('/orders')
					}
				}
				this.initDataInvoice()
			},
			convertChannel(channel) {
				switch (channel.toLowerCase()) {
					case 'wx':
						return "微信訂單"
					case 'wechat':
						return "微信訂單"
					case 'oms':
						return "客服門店訂單"
					case 'mg':
						return "網絡訂單"
					case 'myo':
						return 'MyO訂單'
					case 'moblieapp':
						return 'MobileApp訂單'
					default:
						return channel+'訂單'
						break;
				}
			},
			async initDataInvoice() {
				this.CanCancelInvoice = false;

				//canInvoice
				if (this.order.orderStatus == '30' || this.order.channel == "HWG") {
					//訂單狀態：作廢，隱藏審核發票按鈕
					this.canInvoice = false;
					return;
				}

				await this.getWechatUserInfoAction();//獲取用戶數據

				//判斷訂單是否超過30天
				var now = new Date();
				var DateAdd30 = new Date(now.getFullYear(), now.getMonth()- 1, now.getDate());
				//console.log('DateAdd30');
				//console.log(DateAdd30.getFullYear()+'-'+DateAdd30.getMonth()+'-'+DateAdd30.getDate())
				//var DateAdd30 = new Date();
				var createTime = Date.parse(this.order.createTime.replace(/-/g, '/'));
				// var isEffective = false;
				// if (DateAdd30.getTime() <= createTime) {
				// 	isEffective = true;
				// }
				//var OpenDay=new Date(2018, 11, 16);
				console.log('Valid OpenDay')
				console.log(this.order.createTime)
				var OpenDay=new Date(2018, 11, 16);
				if(createTime<OpenDay.getTime()){
					this.canInvoice = false;
					console.log('Valid OpenDay Close')
					return;
				}
				else{
					console.log('Valid OpenDay Open')
				}

				//查詢申請的發票信息
				let orderno = this.$route.query.orderNo;
				let responseOrderInvoice = await this.getOrderInvoiceAction(orderno);
				console.log('發票申請信息');
				console.log(responseOrderInvoice);
				if (responseOrderInvoice) {
					if(responseOrderInvoice.Value2>0){
						this.canInvoice = false;
						return;
					}
					if (responseOrderInvoice.Value.length >= 1) {
						this.invoice = responseOrderInvoice.Value[0];
						this.invoice.CompanyTypeText=this.CompanyTypeText;
						this.InvoiceStatusBtnText = '查看發票詳情'

						var createTime = Date.parse(this.invoice.CreateTime.replace(/-/g, '/'));
						
						if (DateAdd30.getTime() <= createTime && this.invoice.InvoiceStatus=='10' && this.invoice.IsCancel==0) {
							this.CanCancelInvoice = true;
						}
						console.log('this.CanCancelInvoice:'+this.CanCancelInvoice)
					}
					else
					{
						this.invoice={
							TaxPayerId: '',
							InvoiceTitle: '個人',
							CompanyTypeText: '個人',
							CompanyType: '03',
							Address: '上海',
							Phone: '',
							BankName: '',
							BankNo: '',
							Email: '',
							InvoiceStatus: '0'
						}
						
						this.InvoiceStatusBtnText='申請開具發票'
					}
				}

				// if (this.InvoiceStatus == 0 && isEffective == false) {
				// 	//未提交過發票信息且超過訂單時間30天，隱藏申請發票按鈕
				// 	this.canInvoice = false;
				// 	return;
				// }

				if(this.InvoiceStatus == 0){
					//未開票時，查詢發票擡頭記錄曆史列錶，文本框填充上次申請的記錄
					let responseInvoiceInfo = await this.getInvoiceInfoAction(orderno);
					console.log('發票擡頭記錄曆史列錶');
					console.log(responseInvoiceInfo);
					if (responseInvoiceInfo) {
						this.invoiceInfo = responseInvoiceInfo;

						//初始化
						if (this.invoiceInfo.length != 0) {
							this.invoiceCompany = this.invoiceInfo.length - 1;

							// this.invoice.CompanyTypeText = '企業';
							// this.invoice.CompanyType = '01';
							this.chooseInvoiceInfo();
						}
					}
					console.log('開票狀態');
					console.log(this.InvoiceStatus);
				}
				this.InvoiceLoad = true;//加載完成，顯示發票模塊
			},
			async cancelInvoice() {
				this.showInvoice = false;
			},
			async submitInvoice() {
				if (this.invoice.InvoiceTitle == '') {
					this.$Modal.info({
						title: '信息',
						content: '請填寫發票擡頭'
					});
					return;
				}
				if (!/^[\u4e00-\u9fa5a-zA-Z0-9()（）]+$/.test(this.invoice.InvoiceTitle)) {
					this.$Modal.info({
						title: '信息',
						content: '發票擡頭不能含有特殊字符，請確認後重新輸入'
					});
					return;
				}

				if (this.InvoiceStatus == 0) {
					let orderno = this.$route.query.orderNo;
					//驗證納稅人識別號格式，排除個人和機關事業單位的類型
					if (this.invoice.CompanyType != '03' && this.invoice.CompanyType != '02' ) {
						if (this.invoice.TaxPayerId == '') {
							this.$Modal.info({
								title: '信息',
								content: '請填寫納稅人識別號'
							});
							return;
						}
						if (this.invoice.TaxPayerId.length != 18 && this.invoice.TaxPayerId.length != 15) {
							//this.confirmInvoice=true;識別號錯誤允許提交
							this.$Modal.info({
								title: '信息',
								content: '您輸入的納稅人識別號有誤，請確認後重新輸入'
							});
							return;
						}
						// var reg = /^[1-9]+[0-9]*]*$/; //判斷字符串是否為數字 ，判斷正整數用/^[1-9]+[0-9]*]*$/
						// if (!reg.test(this.invoice.TaxPayerId) && this.invoice.TaxPayerId.length == 15) {
						// 	this.$Modal.info({
						// 		title: '信息',
						// 		content: '您輸入的納稅人識別號格式有誤，請確認後重新輸入'
						// 	});
						// 	return;
						// }
						var re = /^[0-9a-zA-Z]*$/g;  //判斷字符串是否為數字和字母組合     //判斷正整數 /^[1-9]+[0-9]*]*$/  
						if (!re.test(this.invoice.TaxPayerId)) {
							this.$Modal.info({
								title: '信息',
								content: '您輸入的納稅人識別號格式有誤，請確認後重新輸入'
							});
							return;
						}
					}
					else{
						this.invoice.TaxPayerId='';//機關單位類型不需要納稅識別號
					}
					await this.postInvoice();
				}
				else{
					//查看模式，直接關閉
					this.showInvoice = false;
				}
			},
			async postInvoice() {
				let orderno = this.$route.query.orderNo;
				if (this.invoice.CompanyType != '03') {
					if (this.invoiceInfo.length < 10) {
						let responseInvoiceInfo = await this.postInvoiceInfoAction(this.invoice);
						console.log('保存發票擡頭信息');
						console.log(responseInvoiceInfo);
					}
				}
				var argOrderInovice = {
					OrderNo: orderno,
					OriginalID: this.order.originalID,
					OrderDate: this.order.createTime,
					InvoiceAmount: this.order.grandTotal,
					invoice: this.invoice
				}
				let responseOrderInovice = await this.postOrderInoviceAction(argOrderInovice);
				console.log('申請開發票');
				console.log(responseOrderInovice);
				if (responseOrderInovice.Result == 1) {
					//操作成功
					this.$Modal.info({
						title: '信息',
						content: responseOrderInovice.Remark
					});
					this.showInvoice = false;
					this.initDataInvoice()
				}
				else {
					if (responseOrderInovice.Remark) {
						//購貨方納稅人識別號格式錯誤
						if (responseOrderInovice.Remark.indexOf('購貨方納稅人識別號格式錯誤') >= 0) {
							this.$Modal.info({
								title: '信息',
								content: '購貨方納稅人識別號格式錯誤'
							});
						}
						else {
							this.$Modal.info({
								title: '信息',
								content: responseOrderInovice.Remark
							});
						}
					}
					else {
						this.$Modal.info({
							title: '信息',
							content: responseOrderInovice.msg
						});
					}
				}
			},
			async chooseInvoiceInfo() {
				this.invoice.Address = this.invoiceInfo[this.invoiceCompany].Address;
				this.invoice.BankName = this.invoiceInfo[this.invoiceCompany].BankName;
				this.invoice.BankNo = this.invoiceInfo[this.invoiceCompany].BankNo;
				this.invoice.CompanyType = this.invoiceInfo[this.invoiceCompany].CompanyType;
				this.invoice.CompanyTypeText=this.CompanyTypeText;
				this.invoice.Email = this.invoiceInfo[this.invoiceCompany].Email;
				this.invoice.InvoiceTitle = this.invoiceInfo[this.invoiceCompany].InvoiceTitle;
				this.invoice.Phone = this.invoiceInfo[this.invoiceCompany].Phone;
				this.invoice.TaxPayerId = this.invoiceInfo[this.invoiceCompany].TaxPayerId;
				this.invoice.ID = this.invoiceInfo[this.invoiceCompany].ID;
			},
			async deleteInvoiceInfo() {
				let orderno = this.$route.query.orderNo;
				let response = await this.postDeleteInvoiceInfoAction(this.invoiceInfo[this.invoiceCompany].ID);
				console.log(response);
				if (response == 1) {
					//操作成功
					this.$Modal.info({
						title: '信息',
						content: '刪除成功！'
					});
					//刷新發票擡頭列錶
					let responseInvoiceInfo = await this.getInvoiceInfoAction(orderno);
					console.log(responseInvoiceInfo);
					if (responseInvoiceInfo) {
						this.invoiceInfo = responseInvoiceInfo;
					}
				}
				else {
					this.$Modal.info({
						title: '信息',
						content: '刪除失敗！'
					});
				}

			},
			async InvoinceDown() {
				let orderno = this.$route.query.orderNo;
				let reponse = await this.GetInvoiceDownAction(orderno);
				if (reponse.code == 1) {
					//this.$router.push(reponse.pdfUrl);
					// this.$Modal.info({
					// 	title: '信息',
					// 	content: reponse.pdfUrl
					// });
					this.pdfUrl = reponse.pdfUrl;
					this.showInvoiceLink = true;

					//獲取接收發票的郵箱地址
					
					let reponseEmail = await this.getInvoiceEmailAction();
					this.InvoiceEmail=reponseEmail
				}
				else {
					this.$Modal.info({
						title: '信息',
						content: reponse.message
					});
				}
			},
			async InvoinceCancel(){
				var _this=this
				this.$Modal.confirm({
					title: '信息',
					content: '發票作廢後僅有一次重開機會，且重開的發票將無法作廢，請謹慎操作！<br>請再次確認是否需要取消開具的發票？',
					loading:true,
					onOk: async () => {
						let reponse = await _this.GetInvoiceCancelAction(this.invoice.Id);
						if(reponse==1){
							_this.$Modal.info({
								title: '信息',
								content: '取消成功！'
							});
						}
						else{
							_this.$Modal.info({
								title: '信息',
								content: '取消失敗！'
							});
						}
						await _this.initDataInvoice();
						_this.$Modal.remove();
					}
				});
			},
			cancelInvoiceLink() {
				this.showInvoiceLink = false;
			},
			async PostInvoiceEmail(){
				if (this.InvoiceEmail=='') {
					this.$Modal.info({
						title: '信息',
						content: '請輸入郵箱地址！'
					});
					return;
				}

				if (!(RE_EMAIL.test(this.InvoiceEmail))) {
					this.$Modal.info({
						title: '信息',
						content: '郵箱格式不正確請重新輸入！'
					});
					return;
				}
				var params={RecordId:this.invoice.Id,EmailAddress:this.InvoiceEmail}
				let reponse = await this.postInvoiceEmailAction(params);
				if(reponse){
					this.$Modal.info({
						title: '信息',
						content: '發送成功！'
					});
				}
				this.showInvoiceLink = false;
			},
			async changeAddress(){
            	this.editAddress = {
                    id:0,
                    orderNo:this.order.originalID,
                    name:this.delivery.Name,
                    province_id:parseInt(this.delivery.Province),
                    city_id:parseInt(this.delivery.City),
                    county_id:parseInt(this.delivery.County),
                    town_id:parseInt(this.delivery.Town),
                    street:this.delivery.Street,
                    zip :this.delivery.Zip,
                    moblie_phone:this.delivery.MobliePhone,
                    address_type:2,
                    tag_type:'',
					is_default:false,
					whetherAddress:false
                }
                this.show = true;
            },
			async asyncOK(address){
				let now = new Date()
				let payTime = util.formatDate.dateFromStr(this.order.createTime)
				if (now - payTime > 1800000)  {
					this.show = false;
					this.$Message.error('訂單已經發貨不可以修改')
					return
				}
                this.addressLoading = true;
                var obj= {
                    Id:address.id,
                    Name:address.name,
                    MobliePhone:address.moblie_phone,
                    Province:address.province_id,
                    City:address.city_id,
                    County:address.county_id,
                    Town:address.town_id,
                    Street:address.street,
                    Zip:address.zip,
                    AddressType:address.address_type,
                    Tags:address.tag_type,
                    IsDefault:address.is_default?1:0,
                    CustomerId:this.userInfo.value.binding.user_id,
                    orderNo:this.order.originalID,
                    omsOrderNo:this.order.orderId,
                    Remark:'',
                };
                let response = await this.changeOrderAddressAction(obj)
                if (response > 0) {
					 if(address.whetherAddress){
                        await this.postAddAddressAction(obj)
                    }
                	this.$Message.success('地址修改成功')
                	await this.initData()
                } else {
                	let message = ''
                    if(response == -1){
                        message = '訂單不存在或者訂單已經發貨或者已經取消不可以修改'
                    } else if(response == -2){
                        message = '訂單正在處理中，請稍後修改'
                    } else {
                        message = '地址修改失敗'
                    }
                	this.$Message.error(message)
                }
                this.show = false;
                this.addressLoading = false;

            },
		},
	}
</script>

<style lang="scss" scoped>
	@import "@/style/common";
	@import "@/style/mixin";
	.topbar {
		background-color: #f3f4f5;
		a {
			line-height: 40px;
			margin-left: 10.42vw;
			&:hover {
				color: $theme-color;
			}
		}
	}
	.content {
		padding-top: 10px;
		width: 80%;
		margin: auto;
		list-style: none;
		margin-bottom: 50px;
	}
	.order-detail {
		margin-top: 0.5rem;
	}

	.order-left { 
		border-right: 1px solid rgba(0, 0, 0, 0.05);
		padding: 0;
		color: #666;
		background-color: #fbfbfb;
		font-size: 13px;
	}

	.order-info,
	.track h3 {
		border-bottom: 1px solid rgba(0, 0, 0, 0.05);
		line-height: 2;
		font-size: 15px;
		padding-left: 16px;
		background-color: #f5f5f5;
	}

	.track-detail {
		font-size: 15px;
		line-height: 2.5;
		padding-left: 16px;
		padding-top: 10px;
	}

	.products {
		margin-top: 0.5rem;
	}

	.fee {
		line-height: 2;
		margin: 0.5rem auto;
		color: #666;
		font-size: 12px;
	}

	.show-btn {
		margin-left: 0.2rem;
		color:$theme-color;
	}

	.track-list {
		width: 100%;
		border: none;
		height: 350px;
	}

	.Invoice-list {
		line-height: 40px;
		font-size: 14px;
		width: 100%;

	}

	.Invoice-head {
		text-align: right;
		width: 25%;
		padding-right: 15px;
	}

	.Invoice-content {
		/*padding-right:20%*/

	}

	.Invoice-right {
		width: 20%;
	}

	.btn-invoiceDelete {
		float: left;
	}

	.invoice-icon {
		color: red;
	}

	.orderdetail-down {
		font-size: 12px;
		margin-left: 5px;
		color: #BC86C8;
	}

	.orderdetail-downLink {
		font-size: 12px;
		margin-left: 5px;
		color: #ffffff;
		padding-left: 15px;
		padding-right: 15px;
		padding-top: 6px;
		padding-bottom: 6px;

	}
</style>